/**
 * Class strings the catalog editor's parts share (plan section 13, G13; the
 * design skill .claude/skills/siteoperations-design/SKILL.md). The generic
 * buttons and fields come from frontend/src/ui/styles (imported by file path);
 * these are the editor's compositions over the same tokens: 44 px targets on
 * mobile collapsing from sm:, primary blue for chrome only, dark: classes on
 * everything, text-sm body, text-xs meta, text-[10px] micro-labels.
 */

/** A card or panel (the design skill's card recipe). */
export const cardCls = 'rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800';

/** A micro-label (text-[10px] uppercase tracking-widest). */
export const microLabelCls = 'text-[10px] font-semibold uppercase tracking-widest text-gray-500 dark:text-gray-400';

/** A form label. */
export const labelCls = 'block text-xs font-medium text-gray-700 dark:text-gray-300';

/** Help text under a field. */
export const hintCls = 'text-xs text-gray-500 dark:text-gray-400';

/** A section heading inside a sub-view (never larger than text-lg, section 13). */
export const subheadingCls = 'text-sm font-semibold text-gray-900 dark:text-gray-100';

/** The table recipe. */
export const tableWrapCls = 'overflow-x-auto rounded-xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800';
export const thCls = 'px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 dark:text-gray-400';
export const tdCls = 'px-4 py-3 text-sm text-gray-900 dark:text-gray-100';
export const rowCls = 'transition-colors duration-150 hover:bg-gray-50 dark:hover:bg-gray-700/50';

/** A text link in the primary chrome color. */
export const linkCls =
  'font-medium text-primary-700 underline-offset-2 hover:underline focus:outline-none focus:ring-2 focus:ring-primary-500 dark:text-primary-400';

/** A list row that is a button (the section and slide lists). */
export function listRowCls(active: boolean): string {
  const base =
    'flex min-h-[44px] w-full items-center gap-2 rounded-lg px-2.5 text-left text-sm font-medium transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-primary-500 sm:min-h-0 sm:py-1.5';
  return active
    ? `${base} bg-primary-50 text-primary-700 dark:bg-primary-900/20 dark:text-primary-400`
    : `${base} text-gray-700 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-gray-700`;
}

/** A small count badge (a lint count beside a section). */
export const countBadgeCls =
  'ml-auto inline-flex items-center rounded-full bg-red-100 px-2 py-0.5 text-xs font-semibold text-red-800 dark:bg-red-900/40 dark:text-red-300';

/** A checkbox. */
export const checkboxCls =
  'h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-2 focus:ring-primary-500 dark:border-gray-600 dark:bg-gray-700';
